document.addEventListener('teeinblue-event-after-cart-added', () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
        fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
        .then(res => res.json())
        .then(res => drawer.renderContents({sections: res}));
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
    }
});
window.addEventListener('xboost-open-cart', function () {
  setTimeout(function() {
      renderCustomizationImage();
  }, 1000)
})

function renderCustomizationImage() {
  fetch("/cart.js")
  .then(response => response.json())
  .then(data => {
      const items = data.items;
      const cartProducts = document.querySelectorAll(".xb_slide_cart_product");
  
      items.forEach((item, index) => {
          if (item.properties && item.properties._customization_image) {
              const imageUrl = item.properties._customization_image;
              const cartProduct = cartProducts[index];
              if (cartProduct) {
                  const imageElement = cartProduct.querySelector(".xb-img-cover");
                  if (imageElement) {
                      imageElement.src = imageUrl;
                    
                      const parent = imageElement.closest('.xb-img-flip-group');
                      if (parent) {
                          parent.style.pointerEvents = 'none';
                      }
                  }
                
                  const secondImageElement = cartProduct.querySelector(".xb-object-cover");
                  if(secondImageElement) secondImageElement.remove();
              }
          }
      });
  })
  .catch(error => console.error("Error fetch cart.js:", error));
}